import { constantRouterMap, asyncRouterMap } from '@/router/index'


function hasPermission (menus, route) {
  if (route.name) {
    let currMenu = getMenu(route.meta.id, menus)
    if (currMenu != null) {
      // 设置菜单的标题、图标和可见性
      if (currMenu.name != null && currMenu.name !== '') {
        route.meta.title = currMenu.name
      }
      if (currMenu.icon != null && currMenu.icon !== '') {
        route.meta.icon = currMenu.icon
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort
      }
      return true
    } else {
      route.sort = 0
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort = -1
        return true
      } else {
        return false
      }
    }
  } else {
    return true
  }
}

//根据路由meta中的id获取菜单
function getMenu (id, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i]
    if (id === menu.id) {
      return menu
    }
  }
  return null
}

// 对菜单进行排序
function sortRouters (accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i]
    if (router.children && router.children.length > 0) {
      router.children.sort(compare("sort"))
    }
  }
  accessedRouters.sort(compare("sort"))
}

// 升序比较函数
function compare (p) {
  return function (m, n) {
    let a = m[p]
    let b = n[p]
    return a - b
  }
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes ({ commit }, menus) {
      return new Promise(resolve => {
        // const menus = data
        const accessedRouters = asyncRouterMap.filter(v => {
          if (hasPermission(menus, v)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter(child => {
                if (hasPermission(menus, child)) {
                  return child
                }
                return false
              })
              return v
            } else {
              return v
            }
          }
          return false
        })
        // 对菜单进行排序
        sortRouters(accessedRouters)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission